import { type KickPlateBoltHoles } from 'metalworks-domain'

import { DistanceDimensionSlider } from '@salsita-ai/platform-project-sdk/react'
import { PropertyContainer } from '@salsita-ai/platform-project-sdk/ui'

import { GenericDistancePropertyContainerItem } from './GenericDistancePropertyPage'
import { KickPlateHolesCountPropertyPage } from './KickPlateHolesCountPropertyPage'

interface Props {
  id: KickPlateBoltHoles['id']
}

export const KickplateBoltHolePropertyPage = (props: Props) => {
  const { id } = props

  return (
    <PropertyContainer.Group spacing="large">
      <GenericDistancePropertyContainerItem id={id} />
      <PropertyContainer.Item title="Diameter">
        <DistanceDimensionSlider entityId={id} instanceName="diameter" />
      </PropertyContainer.Item>
      <KickPlateHolesCountPropertyPage id={id} />
    </PropertyContainer.Group>
  )
}
